/*
 * Copyright (c) 2019 - Bas Milius <bas@mili.us>
 *
 * This file is part of the Latte Framework package.
 *
 * For the full copyright and license information, please view the
 * LICENSE file that was distributed with this source code.
 */

import "@mdi/font/scss/materialdesignicons.scss";
import moment from "moment";
import vue from "vue";

self.moment = moment;
self.Vue = vue;
